export enum StatusEvento {

  INICIADO = 'INICIADO',
  SUCESSO  = 'SUCESSO',
  FALHA    = 'FALHA'

}